import { render, staticRenderFns } from "./TahsilatlarAyChart.vue?vue&type=template&id=189489d0&scoped=true"
import script from "./TahsilatlarAyChart.vue?vue&type=script&lang=ts"
export * from "./TahsilatlarAyChart.vue?vue&type=script&lang=ts"
import style0 from "./TahsilatlarAyChart.vue?vue&type=style&index=0&id=189489d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189489d0",
  null
  
)

export default component.exports